export default {
  ScoreModel: {
    uid: "",
    k1: "",
    pt:'',
    jobs: [],
    times: 0, //速度赛次数
    violationTimes: 0, //速度赛犯规扣分次数
    m_pa: 0, //失误Pa
    m_q: 0, //失误Q
    m_m: 0, //失误m
    m_v: 0, //违例v
    m_sv: 0, //空间违例
    m_b: 0, //间歇b
    t_ca: 0,//创意编排分
    t_cq: 0,//完成质量分
    d: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    da: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    db: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    dp: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    dm: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    dr: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    dj: [
      { l: "1-级", v: 1.3554, t: 0 },
      { l: "1级", v: 1.5, t: 0 },
      { l: "1+级", v: 1.8371, t: 0 },
      { l: "2-级", v: 2.0331, t: 0 },
      { l: "2级", v: 2.25, t: 0 },
      { l: "2+级", v: 2.7556, t: 0 },
      { l: "3-级", v: 3.0496, t: 0 },
      { l: "3级", v: 3.375, t: 0 },
      { l: "3+级", v: 4.1335, t: 0 },
      { l: "4-级", v: 4.5744, t: 0 },
      { l: "4级", v: 5.0625, t: 0 },
      { l: "4+级", v: 6.2002, t: 0 },
      { l: "5-级", v: 6.8617, t: 0 },
      { l: "5级", v: 7.5937, t: 0 },
      { l: "5+级", v: 9.3004, t: 0 },
    ],
    dt: [
      { l: "1-级", v: 1.3554, t: 0 },
      { l: "1级", v: 1.5, t: 0 },
      { l: "1+级", v: 1.8371, t: 0 },
      { l: "2-级", v: 2.0331, t: 0 },
      { l: "2级", v: 2.25, t: 0 },
      { l: "2+级", v: 2.7556, t: 0 },
      { l: "3-级", v: 3.0496, t: 0 },
      { l: "3级", v: 3.375, t: 0 },
      { l: "3+级", v: 4.1335, t: 0 },
      { l: "4-级", v: 4.5744, t: 0 },
      { l: "4级", v: 5.0625, t: 0 },
      { l: "4+级", v: 6.2002, t: 0 },
      { l: "5-级", v: 6.8617, t: 0 },
      { l: "5级", v: 7.5937, t: 0 },
      { l: "5+级", v: 9.3004, t: 0 }
    ],
    p: {
      pa: [
        //动作技能
        { g: "Pa动作技能", l: "好（+）", v: 1, t: 0 },
        { g: "Pa动作技能", l: "中（√）", v: 0, t: 0 },
        { g: "Pa动作技能", l: "差（-）", v: -1, t: 0 },
      ],
      pre: [
        //娱乐编排
        { g: "Pr娱乐编排", l: "好（+）", v: 1, t: 0 },
        { g: "Pr娱乐编排", l: "中（√）", v: 0, t: 0 },
        { g: "Pr娱乐编排", l: "差（-）", v: -1, t: 0 },
      ],
      prm: [
        //音乐运用
        { g: "Pr音乐运用", l: "好（+）", v: 1, t: 0 },
        { g: "Pr音乐运用", l: "中（√）", v: 0, t: 0 },
        { g: "Pr音乐运用", l: "差（-）", v: -1, t: 0 },
      ],
      fs: [
        //形式风格
        { g: "Fs形式风格", l: "好（+）", v: 1, t: 0 },
        { g: "Fs形式风格", l: "中（√）", v: 0, t: 0 },
        { g: "Fs形式风格", l: "差（-）", v: -1, t: 0 },
      ],
    },
    p2: {
      m: [
        { g: "音乐", l: "+", v: 0.2, t: 0 },
        { g: "音乐", l: "√", v: 0.2, t: 0 },
        { g: "音乐", l: "-", v: 0.2, t: 0 },
      ],
      cq: [
        { g: "完成质量", l: "+", v: 0.25, t: 0 },
        { g: "完成质量", l: "√", v: 0.25, t: 0 },
        { g: "完成质量", l: "-", v: 0.25, t: 0 },
      ],
      ca: [
        { g: "创意", l: "+", v: 0.15, t: 0 },
        { g: "创意", l: "√", v: 0.15, t: 0 },
        { g: "创意", l: "-", v: 0.15, t: 0 },
      ],
      r: [
        { g: "娱乐", l: "+", v: 0.25, t: 0 },
        { g: "娱乐", l: "√", v: 0.25, t: 0 },
        { g: "娱乐", l: "-", v: 0.25, t: 0 },
      ],
      v: [
        { g: "多样性/重复性", l: "+", v: 0.15, t: 0 },
        { g: "多样性/重复性", l: "√", v: 0.15, t: 0 },
        { g: "多样性/重复性", l: "-", v: 0.15, t: 0 },
      ],

    },
    u: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_da: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_db: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_dp: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_dm: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_dr: [
      { l: "0.5", v: 0.12, t: 0 },
      { l: "1", v: 0.15, t: 0 },
      { l: "2", v: 0.23, t: 0 },
      { l: "3", v: 0.34, t: 0 },
      { l: "4", v: 0.51, t: 0 },
      { l: "5", v: 0.76, t: 0 },
      { l: "6", v: 1.14, t: 0 },
      { l: "7", v: 1.71, t: 0 },
      { l: "8", v: 2.56, t: 0 },
    ],
    u_dt: [
      { l: "1-级", v: 1.3554, t: 0 },
      { l: "1级", v: 1.5, t: 0 },
      { l: "1+级", v: 1.8371, t: 0 },
      { l: "2-级", v: 2.0331, t: 0 },
      { l: "2级", v: 2.25, t: 0 },
      { l: "2+级", v: 2.7556, t: 0 },
      { l: "3-级", v: 3.0496, t: 0 },
      { l: "3级", v: 3.375, t: 0 },
      { l: "3+级", v: 4.1335, t: 0 },
      { l: "4-级", v: 4.5744, t: 0 },
      { l: "4级", v: 5.0625, t: 0 },
      { l: "4+级", v: 6.2002, t: 0 },
      { l: "5-级", v: 6.8617, t: 0 },
      { l: "5级", v: 7.5937, t: 0 },
      { l: "5+级", v: 9.3004, t: 0 }
    ],
    q: [
      { l: "多摇", v: 4, t: 4 },
      { l: "力量体操", v: 4, t: 4 },
      { l: "缠绕+放绳", v: 4, t: 4 },
    ],
    //精英级花样赛规定元素分
    q2: {
      p: [
        { g: "力量体操", l: "二级或以下", v: 0.5, t: 0 },
        { g: "力量体操", l: "三级或以上", v: 1, t: 0 },
      ],
      m: [
        { g: "多摇", l: "二级或以下", v: 0.5, t: 0 },
        { g: "多摇", l: "三级或以上", v: 1, t: 0 },
      ],
      r: [
        { g: "绳子运用", l: "二级或以下", v: 0.5, t: 0 },
        { g: "绳子运用", l: "三级或以上", v: 1, t: 0 },
      ],
      i: [
        { g: "互相配合", l: "二级或以下", v: 0.5, t: 0 },
        { g: "互相配合", l: "三级或以上", v: 1, t: 0 },
      ]
    },
    //国内集体规定赛-完成质量
    ctr_cq: [
      { t: "动作准确性", s: 0, m: 20 },
      { t: "动作熟练性", s: 0, m: 15 },
      { t: "动作合拍性", s: 0, m: 15 },
      { t: "运动能力一致性", s: 0, m: 15 },
      { t: "表演技巧一致性", s: 0, m: 15 },
    ],
    //国内个人规定赛-完成质量
    cpr_cq: [
      { t: "动作准确性", s: 0, m: 30 },
      { t: "动作熟练性", s: 0, m: 20 },
      { t: "动作合拍性", s: 0, m: 30 },
    ],
    //国内个人/团队规定赛-创意编排
    cr_ca: [
      { t: "过度连接、成套创编、场地运用", s: 0, m: 10 },
      { t: "现场表现效果", s: 0, m: 10 },
    ],
    //国内赛-难度分
    c_d1: {
      l: "一级难度", v: 1, t: 0, jobs: ['【国内表演赛】一级难度', '【国内花样赛】一级难度', '【国内集体个人花样】一级难度']
    },
    c_d2: {
      l: "二级难度", v: 2, t: 0, jobs: ['【国内表演赛】二级难度', '【国内花样赛】二级难度', '【国内集体个人花样】二级难度']
    },
    c_d3: {
      l: "三级难度", v: 3, t: 0, jobs: ['【国内表演赛】三级难度', '【国内花样赛】三级难度']
    },
    //国内赛-重复难度
    c_u1: {
      l: "一级难度", v: -1, m: 20, t: 0, jobs: ['【国内表演赛】重复一级难度', '【国内花样赛】重复一级难度', '【国内集体个人花样】重复一级难度']
    },
    c_u2: {
      l: "二级难度", v: -2, m: 20, t: 0, jobs: ['【国内表演赛】重复二级难度', '【国内花样赛】重复二级难度', '【国内集体个人花样】重复二级难度']
    },
    c_u3: {
      l: "三级难度", v: -3, t: 0, jobs: ['【国内表演赛】重复三级难度', '【国内花样赛】重复三级难度']
    },
    //国内表演赛-规定元素分
    c_q: [
      { l: "个人绳", v: 1, t: 1 },
      { l: "车轮跳", v: 1, t: 1 },
      { l: "交互绳", v: 1, t: 1 },
      { l: "长绳", v: 1, t: 1 },
      { l: "旅行跳", v: 1, t: 1 },
    ],
    //精英级表演赛规定元素
    e_q: [
      { l: "个人绳", v: 1, t: 1 },
      { l: "车轮跳", v: 1, t: 1 },
      { l: "交互绳", v: 1, t: 1 },
      { l: "长绳", v: 1, t: 1 },
      { l: "旅行跳", v: 1, t: 1 },
    ],
    //国内花样赛-规定元素分
    c_q2: [
      { l: "力量、体操", v: 4, t: 4, jobs: ['【国内花样赛】规定元素：力量体操'] },
      { l: "多摇", v: 4, t: 4, jobs: ['【国内花样赛】规定元素：多摇'] },
      { l: "绳子运用", v: 4, t: 4, jobs: ['【国内花样赛】规定元素：绳子运用'] },
      { l: "互相配合", v: 4, t: 4, jobs: ['【国内花样赛】规定元素：互相配合'] }
    ],
    //国内个人规定赛-创意编排
    c_ca: [
      { t: "音乐", s: 0, m: 10 },
      { t: "表现力", s: 0, m: 10 },
      { t: "创新性", s: 0, m: 10 },
      { t: "多样性", s: 0, m: 10 },
      { t: "空间", s: 0, m: 10 },
    ],
    //国内个人规定赛-完成质量分
    c_cq: [
      { l: "小错误", t: 0, v: -1 },
      { l: "中错误", t: 0, v: -2 },
      { l: "大错误", t: 0, v: -3 },
      { l: "失误", t: 0, v: -5 },
    ],
  }
}